import * as React from "react";

const SvgComponent = (props) => (
  <svg
    viewBox="0 0 15 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <mask id="a" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.732.253c-.512.099-.587.774-.165 1.08.43.313.842.663 1.23 1.051 3.993 3.994 3.993 10.468 0 14.461a10.214 10.214 0 0 1-2.686 1.933c-.467.232-.506.91-.018 1.093a10.228 10.228 0 0 0 10.818-2.348c3.993-3.994 3.993-10.468 0-14.462A10.215 10.215 0 0 0 2.732.253Z"
      />
    </mask>

    <path
      d="m1.111 18.778.667 1.344-.667-1.344ZM2.567 1.333l-.882 1.214.882-1.214Zm.165-1.08.284 1.472L2.732.253ZM1.685 2.547c.367.267.719.566 1.05.898l2.122-2.121A11.802 11.802 0 0 0 3.45.12L1.685 2.547Zm1.05.898a8.726 8.726 0 0 1 0 12.34l2.122 2.121c4.58-4.58 4.58-12.003 0-16.582l-2.121 2.12Zm0 12.34a8.713 8.713 0 0 1-2.29 1.65l1.333 2.687a11.714 11.714 0 0 0 3.08-2.216l-2.122-2.121Zm8.115.677a8.727 8.727 0 0 1-9.231 2.003l-1.05 2.81c4.166 1.558 9.047.664 12.403-2.692l-2.122-2.121Zm0-12.34a8.726 8.726 0 0 1 0 12.34l2.122 2.121c4.579-4.579 4.579-12.003 0-16.582L10.85 4.122ZM3.016 1.725a8.715 8.715 0 0 1 7.834 2.397l2.122-2.121A11.715 11.715 0 0 0 2.448-1.22l.568 2.945ZM.444 17.435a2.157 2.157 0 0 0-1.2 1.86c-.024.778.4 1.635 1.324 1.98l1.05-2.81a.975.975 0 0 1 .625.925.843.843 0 0 1-.465.732L.444 17.434ZM3.45.12c.261.19.377.502.336.798a.974.974 0 0 1-.769.807L2.447-1.22C1.48-1.033.918-.26.813.512c-.1.735.189 1.538.872 2.035L3.45.12Z"
      fill="currentColor"
      stroke="currentColor"
      mask="url(#a)"
    />
  </svg>
);

export default SvgComponent;
